import { eventsDuck } from '@eb/redux-destination';
import { EventSearchResponse } from '../../types';

/**
 *
 * @param searchResponse
 * @param userCollections
 *
 * Given a search API response and list of user collection IDs,
 * returns the union of the two. An array of collection IDs
 * that belong the user and the event is already a member of.
 *
 * Necessary step to handle leveraging the search API to pull
 * this data.
 *
 * EB-[] Eventually this should be able to be queried directly via
 * a collection specific API.
 */
export const parseEventCollectionResponse = (
    eventSearchResponseWithAggs: EventSearchResponse,
    userCollectionIds: string[],
) => {
    const eventExistsInUserCollection =
        eventSearchResponseWithAggs.results.length > 0;

    if (eventExistsInUserCollection) {
        const collectionIds = eventSearchResponseWithAggs.aggs.collection.buckets.map(
            (bucket: { key: string }) => bucket?.key || '',
        );

        const mergedCollections = userCollectionIds.filter((id: string) =>
            collectionIds.includes(id),
        );

        return mergedCollections;
    }
};

export const loggedOutSaveRedirect = (eventId: string) => {
    eventsDuck.api.loggedOutSaveRedirect(eventId, {
        pathname: window.location.pathname,
    });
};
